import React from 'react';

const WhyChoose = () => (
  <section className="why-choose">
    <h2>Why Choose SP Rao Technologies?</h2>
    <ul>
      <li>✅ Proven Track Record: 80% placement rate</li>
      <li>✅ Experienced Trainer: Mr. S.P. Rao</li>
      <li>✅ Hands-On Training: Project-based learning</li>
      <li>✅ Industry Recognition: Trusted by top companies</li>
      <li>✅ Student-Centric Approach: Personalized mentorship</li>
      <li>✅ Affordable & Accessible: Competitive pricing</li>
    </ul>
  </section>
);

export default WhyChoose;